// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"fba21bae","278":"4699f6ec","305":"51c6236f","370":"036fa060","453":"2221799f","552":"5ebdb91d","783":"73e65926","850":"f3077832"}[chunkId] + ".chunk.js";
};